<template>
  <a-drawer width="35%" :label-col="4" :wrapper-col="14" :visible="visible" @close="visible = false">
    <a-divider orientation="left">
      <b>修改版本信息</b>
    </a-divider>
    <a-form-model ref="form" :model="form" :rules="rules">
      <a-form-model-item label="APP类型">
        <a-radio-group name="radioGroup" :default-value="1" v-model="form.appType" disabled>
          <a-radio :value="0">Android</a-radio>
          <a-radio :value="1">IOS</a-radio>
        </a-radio-group>
      </a-form-model-item>
      <a-form-model-item label="版本号" prop="versionCode" >
        <a-input v-model="form.versionCode" placeholder="请输入" />
      </a-form-model-item>
      <a-form-model-item label="版本名称" prop="versionName" >
        <a-input v-model="form.versionName" placeholder="请输入" />
      </a-form-model-item>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            保存
          </a-button>
          <a-button type="dashed" @click="visible = false">
            取消
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import { addDeviceData } from '@/api/com/version.js'
import Editor from '@/components/Editor'
export default {
  name: 'CreateForm',
  components: { Editor },
  data () {
    return {
      visible: false,
      submitLoading: false,
      form: {},
      rules: {
        versionCode: [{ required: true, message: '版本号不能为空', trigger: 'blur' }],
        versionName: [{ required: true, message: '版本名称不能为空', trigger: 'blur' }]
      }
    }
  },
  methods: {
    init (info) {
      this.form = { ...info }
      this.visible = true
    },
    /** 提交按钮 */
    submitForm() {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          addDeviceData({ ...this.form, upUrlType: 1, upUrl: '12' }).then(response => {
            this.$message.success('修改成功', 3)
            this.visible = false
            this.$emit('ok')
          }).finally(() => {
            this.submitLoading = false
          })
        } else {
          return false
        }
      })
    }
  }
}
</script>
